export const environment = {
    production: false,
    staging: false,
    serverBaseURL: 'http://test.tcmcontentcloud.com',
    serverBase: 'http://test.tcmcontentcloud.com:3000',
    serverBasePort: '',
    gaId: 'UA-169917216-2'
};



// WEBPACK FOOTER //
// ./public/environments/environment.ts